export function slugifySeriesName(value: string | null | undefined) {
  let cleaned = (value || "Uncategorized").trim();
  // Strip season suffixes like " - 2026 Season 2", " - 2025 Season"
  // to match backend normalize_series_name behavior
  cleaned = cleaned.replace(/\s*-\s*\d{4}\s+season(?:\s+\d+)?(?:\s+(?:fixed|open))?\s*$/i, "");
  const slug = cleaned.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  return slug || "uncategorized";
}
